import DepositCardSettings from "@/models/Products/ProductSettings/DefaultSettings/Cards/DepositCardSettings";

export default class UpdateDepositCardSettingsRequest extends DepositCardSettings {
    updatedAt: Date;

    public constructor(settings: DepositCardSettings, updatedAt: Date) {
        super();
        this.updatedAt = updatedAt;
        if (settings) {
            this.overridable = settings.overridable;
        }
    }
}